import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = {
  class: "flex items-center gap-3 mb-4",
  id: "activeFilter"
}
const _hoisted_3 = { style: {"color":"#04776D"} }
const _hoisted_4 = ["aria-label", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "clm-act-cntn"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

import Card from 'primevue/card'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Paginator from '@/views/components/paginator/Paginator.vue'
import ProgressSpinner from 'primevue/progressspinner'
import EmptyState from '@/views/components/list/EmptyState.vue'
import HeaderCustom from '@/views/components/header/HeaderHjpTable.vue'
import moment from 'moment'
import { computed, getCurrentInstance, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import OverlayPanel from 'primevue/overlaypanel'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { getDynamicStatusBg, getDynamicStatusColor, getDynamicStatusName, getDynamicStatusIcon } from '@/utils/helpers/colorStatusLabel'
import cardStatusList from './cardStatusList'
import ListActions from './components/ListActions.vue'
import FilterOptions from './components/FilterOptions.vue'

const headerTitle = 'Kartu Pelanggaran'
const searchPlaceholder = 'Cari Nama Karyawan'
const emptyTable = 'Tidak ada data pelanggaran'
const employeePenaltyEndpoint = 'talent/v1/employeePenalties'

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const app = getCurrentInstance()
const {
  $toast,
  $confirm
} = app!.appContext.config.globalProperties
const refOverlayAction = ref()
const opf = ref()
const router = useRouter()
const store = useStore()
const dataRow = ref(null) as any
const dataSource = ref([]) as any
const dataSourceFilterOptions = ref([]) as any
const isLoading = ref(false)
const appliedFilter = computed(() => store.getters['violenceCard/getViolenceCardFilter'] || [])

const filters = {
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  search: '',
  filterField: ['employeeFullName'],
  custom: [] as any
}

const showDropDown = (evt: any, item: any) => {
  dataRow.value = item
  refOverlayAction.value.toggle(evt)
}

const showFilterDropDownAct = (evt: any, item: any) => {
  dataRow.value = item
  opf.value.toggle(evt)
}

const getPenaltyTypeList = () => {
  store.dispatch('showLoading')
  const payload = '?isActive=true'
  apiUseCase.get(`talent/v1/penaltyTypes${payload}`).then((response) => {
    const { error, result } = response
    if (!error) {
      dataSourceFilterOptions.value = result.data
    }
  })
  store.dispatch('hideLoading')
}

const getAllData = () => {
  store.dispatch('showLoading')
  apiUseCase.get(`${employeePenaltyEndpoint}${returnUrlPrams(filters)}`).then((response) => {
    const { error, result } = response
    if (!error) {
      dataSource.value = result.data
      filters.totalRecords = result.count
    }
  })
  store.dispatch('hideLoading')
}

const onChangePage = (val: any) => {
  console.log('page', val)
  filters.pageNumber = val.page + 1
  filters.pageSize = val.rows
  getAllData()
}

const onSearch = (val: any) => {
  console.log('search')
  filters.search = val
  filters.pageNumber = 1
  getAllData()
}

const onSort = (val: any) => {
  console.log('onSort', val)
}

const onClickBtnAdd = () => {
  console.log('onClickBtnAdd')
  router.push({
    name: 'violation-card-form'
  })
}

const onDetail = (data: any = null) => {
  const encryptedId = encryptDecriptMethods.encrypt(data?.id || dataRow.value.id)
  router.push({
    name: 'violation-card-detail',
    params: { id: encryptedId }
  })
}

const deleteDataAct = async () => {
  store.dispatch('showLoading')
  await apiUseCase.delete(employeePenaltyEndpoint, dataRow.value.id).then((response) => {
    console.log('response')
    const { error, message, code } = response
    if (!error || code === 204) {
      $toast.add({
        severity: 'success',
        summary: 'Kartu Pelanggaran berhasil dihapus',
        group: 'bc',
        // detail: 'Ukuran file melebihi 2MB',
        life: 3000
      })
      getAllData()
    } else {
      $toast.add({
        severity: 'error',
        summary: 'Kartu Pelanggaran gagal Dihapus',
        detail: message,
        group: 'bc',
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const onDelete = async () => {
  $confirm.require({
    header: 'Hapus Kartu Pelanggaran',
    message: 'Apakah anda yakin ingin menghapusnya?',
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      deleteDataAct()
    }
  })
}

const hideFilterPanel = () => {
  opf.value.hide()
}

const onSubmitFilterAct = (selectedStatuses: any[]) => {
  const selectedStatusCodes = selectedStatuses.map((status: any) => status.Code)
  const existingStatusesFilter = filters.custom.find((filter: any[]) => filter[0] === 'statuses')

  if (selectedStatusCodes.length > 1) {
    filters.custom = filters.custom.filter((filter: any[]) => filter[0] !== 'status')
    if (existingStatusesFilter) {
      existingStatusesFilter[2] = selectedStatusCodes.join(', ')
      filters.custom = filters.custom.filter((filter: any[]) => (
        filter[0] !== 'statuses' || filter === existingStatusesFilter
      ))
    } else {
      filters.custom.push(['statuses', '=', selectedStatusCodes.join(', ')])
    }
  } else {
    filters.custom = filters.custom.filter((filter: any[]) => (
      filter[0] !== 'status' && filter[0] !== 'statuses'
    ))
    if (selectedStatusCodes.length === 1) {
      filters.custom.push(['status', '=', selectedStatusCodes[0]])
    }
  }

  filters.pageNumber = 1
  getAllData()
}

const deselectFilterAct = (filterToRemove: any) => {
  const selectedStatuses = appliedFilter.value.filter((filter: any) => filter.Code !== filterToRemove.Code)
  store.dispatch('violenceCard/setViolenceCardFilter', selectedStatuses)
  onSubmitFilterAct(selectedStatuses)
}

onMounted(() => {
  getAllData()
  getPenaltyTypeList()
})

onBeforeUnmount(() => {
  store.dispatch('violenceCard/setViolenceCardFilter', [])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(HeaderCustom, {
            titleHeader: headerTitle,
            titleButton: '',
            onRedirectAdd: onClickBtnAdd,
            showFilter: true,
            placeholder: searchPlaceholder,
            onOnSearch: onSearch,
            showSearch: true,
            showAddBtn: true,
            onShowDropDownFilter: showFilterDropDownAct
          })
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appliedFilter.value, (filter) => {
            return (_openBlock(), _createElementBlock("div", {
              key: filter.Code,
              style: {"{\n              backgroundColor":"#DDF6F3","color":"#04776D","border":"1px solid #04776D"},
              class: "flex items-center gap-2 rounded-lg bg-green-100 px-3 py-1 rounded-full"
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(filter.Name), 1),
              _createElementVNode("button", {
                type: "button",
                class: "pi pi-times cursor-pointer",
                "aria-label": `Hapus filter ${filter.Name}`,
                onClick: ($event: any) => (deselectFilterAct(filter))
              }, null, 8, _hoisted_4)
            ]))
          }), 128))
        ]),
        _createVNode(_unref(DataTable), {
          id: "hjp-data-table",
          value: dataSource.value,
          paginator: false,
          loading: isLoading.value,
          class: "table-og hjp-data-table",
          responsiveLayout: "scroll",
          onSort: onSort
        }, {
          empty: _withCtx(() => [
            _createVNode(EmptyState, { textNoData: emptyTable })
          ]),
          loading: _withCtx(() => [
            _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), { header: "Tanggal Laporan" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.createdAt ? _unref(moment)(slotProps.data.createdAt).format('DD MMM YYYY') : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Tanggal Kejadian" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.penaltyTypeCode.toLowerCase() != 'ylw' ? _unref(moment)(slotProps.data.incidentDate).format('DD MMM YYYY') : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Jenis Pelanggaran" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.penaltyTypeCode.toLowerCase() == 'ylw' ? "Kartu Kuning" : 'Kartu Merah'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Nama Karyawan" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.employeeFullName ?? '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Status" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  style: _normalizeStyle({
                backgroundColor: _unref(getDynamicStatusBg)(_unref(cardStatusList), String(slotProps.data.status))
              }),
                  class: "flex items-center gap-2 rounded-lg px-4 py-1 ml-2 w-fit"
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({
                  color: _unref(getDynamicStatusBg)(_unref(cardStatusList), String(slotProps.data.status)),
                  backgroundColor: _unref(getDynamicStatusColor)(_unref(cardStatusList), String(slotProps.data.status))
                }),
                    class: "rounded-full px-1 py-1 flex items-center justify-center"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_unref(getDynamicStatusIcon)(_unref(cardStatusList), String(slotProps.data.status)))
                    }, null, 2)
                  ], 4),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ color: _unref(getDynamicStatusColor)(_unref(cardStatusList), String(slotProps.data.status)) }),
                    class: "text-sm font-semibold"
                  }, _toDisplayString(_unref(getDynamicStatusName)(_unref(cardStatusList), String(slotProps.data.status))), 5)
                ], 4)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              class: "colom-action mx-auto",
              header: ""
            }, {
              body: _withCtx((slotProps) => [
                (String(slotProps.data.status).toLowerCase() === 'draft')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: "px-4 py-2 flex items-center cursor-pointer rounded-lg",
                        onClick: ($event: any) => (showDropDown($event, slotProps.data))
                      }, _cache[0] || (_cache[0] = [
                        _createElementVNode("i", {
                          class: "pi pi-ellipsis-h",
                          style: {"font-size":"1rem"}
                        }, null, -1)
                      ]), 8, _hoisted_6)
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "text-primary font-semibold cursor-pointer",
                      onClick: ($event: any) => (onDetail(slotProps.data))
                    }, " Lihat Detail > ", 8, _hoisted_7))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ]),
      footer: _withCtx(() => [
        (filters.totalRecords > 0)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 0,
              rows: filters.pageSize,
              totalRecords: filters.totalRecords,
              onOnPage: onChangePage,
              rowsPerPageOptions: [5, 10, 15, 20]
            }, null, 8, ["rows", "totalRecords"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "refOverlayAction",
      ref: refOverlayAction
    }, {
      default: _withCtx(() => [
        _createVNode(ListActions, {
          edit: false,
          del: true,
          showDetail: true,
          editTitle: 'Edit',
          delTitle: 'Hapus',
          showDetailTitle: 'Lihat Detail',
          onDel: onDelete,
          onShowDetail: onDetail
        })
      ]),
      _: 1
    }, 512),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "opf",
      ref: opf
    }, {
      default: _withCtx(() => [
        _createVNode(FilterOptions, {
          dataList: _unref(cardStatusList),
          selectedFilter: filters.custom,
          onOnSubmit: onSubmitFilterAct,
          onHidePanel: hideFilterPanel
        }, null, 8, ["dataList", "selectedFilter"])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})